<ng-template #modaleInterdiction aria-hidden="true" aria-labelledby="codePostalInterdit">
    <div class="modal-header">
        <div aria-level="1" class="texte-medium text-primary" id="codePostalInterdit" role="heading">Code postal {{localite.commune}}</div>
        <button type="button" class="close-cnaf" (click)="fermerModale()" aria-label="Fermer la popup" data-dismiss="modal"></button>
    </div>
    <div class="modal-body" tabindex="0">
        <p>
            Le code postal du logement pour lequel vous voulez faire une simulation n'ouvre pas droit à l'aide au logement
        </p>
    </div>
    <div class="modal-footer">
        <button (click)="fermerModale()" type="button" class="btn btn-form-cnaf btn-secondaire-cnaf" data-dismiss="modal">
            Modifier
        </button>
        <button (click)="redirigerAccueil()" type="button" class="btn btn-form-cnaf btn-secondaire-cnaf">
            Confirmer
        </button>
    </div>
</ng-template>